import {
  AUTH_APP_AUTO_SELECT_STORAGE_KEY,
  AUTH_PORTFOLIO_PREVIOUS_ROUTE_STORAGE_KEY_PREFIX,
  COMPANY_VALUATIONS,
  LEGACY_COMPANY_VALUATIONS_AUTO_SELECT,
  PORTFOLIO_VALUATION,
} from 'common/constants/auth/appSwitch';
import type { AuthAppAutoSelect } from './appSwitch.types';

const AUTH_APP_AUTO_SELECT_VALUES: readonly AuthAppAutoSelect[] = [
  PORTFOLIO_VALUATION,
  COMPANY_VALUATIONS,
];

export const isAuthAppAutoSelect = (value: string): value is AuthAppAutoSelect =>
  (AUTH_APP_AUTO_SELECT_VALUES as readonly string[]).includes(value);

// localStorage helpers for product switch / workspace handoff.
// Keys and stored value literals: common/constants/auth/appSwitch.

export const saveAppAutoSelect = (app: AuthAppAutoSelect): void => {
  localStorage.setItem(AUTH_APP_AUTO_SELECT_STORAGE_KEY, app);
};

export const getAppAutoSelect = (): AuthAppAutoSelect | null => {
  const raw = localStorage.getItem(AUTH_APP_AUTO_SELECT_STORAGE_KEY);

  if (!raw) {
    return null;
  }

  if (raw === LEGACY_COMPANY_VALUATIONS_AUTO_SELECT) {
    localStorage.setItem(AUTH_APP_AUTO_SELECT_STORAGE_KEY, COMPANY_VALUATIONS);
    return COMPANY_VALUATIONS;
  }

  return isAuthAppAutoSelect(raw) ? raw : null;
};

export const clearAppAutoSelect = (): void => {
  localStorage.removeItem(AUTH_APP_AUTO_SELECT_STORAGE_KEY);
};

const portfolioRouteStorageKey = (userId?: number) =>
  userId
    ? `${AUTH_PORTFOLIO_PREVIOUS_ROUTE_STORAGE_KEY_PREFIX}_${userId}`
    : AUTH_PORTFOLIO_PREVIOUS_ROUTE_STORAGE_KEY_PREFIX;

export const savePreviousPortfolioRoute = (route: string, userId?: number): void => {
  localStorage.setItem(portfolioRouteStorageKey(userId), route);
};

const getPreviousPortfolioRoute = (userId?: number): string | null =>
  localStorage.getItem(portfolioRouteStorageKey(userId));

export const clearPreviousPortfolioRoute = (userId?: number): void => {
  localStorage.removeItem(portfolioRouteStorageKey(userId));
};

export const getSafePreviousPortfolioRoute = (userId?: number): string | null => {
  const route = getPreviousPortfolioRoute(userId);

  if (!route) {
    return null;
  }

  const pathOnly = route.split('?')[0] ?? '';

  if (
    pathOnly.startsWith('/')
    && !pathOnly.startsWith('//')
    && !pathOnly.includes('/sign-in')
    && /^\/(firms|funds|companies)\b/.test(pathOnly)
  ) {
    return route;
  }

  clearPreviousPortfolioRoute(userId);
  return null;
};
